const GUESTS = {
  //getGuests
  GUESTS: 'GUESTS',
  //getGuestsDetails
  GUESTS_DETAILS: 'GUESTS_DETAILS',
  //getGuestOccupancies
  GUEST_OCCUPANCIES: 'GUEST_OCCUPANCIES',
  //getGuestsReservations
  GUESTS_RESERVATIONS: 'GUESTS_RESERVATIONS',
};

export default GUESTS;
